import { Box, Flex, IconExport } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import { getGoToHelpDeskEvent, getOpenOrDownloadAppEvent } from 'src/tracking';
import { WebApplicationViewModel } from 'src/viewModels/Products';
import { Item, NoneDecoratedLink, StyledButton } from './ProductItemDesktop';

interface ProductItemWebProps {
    product: WebApplicationViewModel;
}

const ProductItemWeb: FunctionComponent<ProductItemWebProps> = ({ product: { productName, logo, helpDeskUrl, url } }) => {
    const { trackEvent, language } = useContext(AppContext);
    const { t } = useTranslation();

    const helpDeskUrlByLanguage = helpDeskUrl[language === 'de' ? 'de' : 'en'];

    return (
        <Item key={productName} showTwoButtons={false}>
            <span aria-label={`${productName} Logo`}>
                {logo}
            </span>
            <span className="px12_600_contrast" aria-label={productName}>
                {productName}
            </span>
            <Box width='100%'>
                <StyledButton
                    size="normal"
                    variant="secondary"
                    onClick={() => {
                        window.open(url);
                        trackEvent(getOpenOrDownloadAppEvent(`${productName}`));
                    }}
                    aria-label={`Open ${productName}`}
                >
                    {t('UserProfile.open_button', 'Open')}
                </StyledButton>
            </Box>
            <Flex width='100%' justifyContent='center' className='px12_600_normal'>
                {'—'}
            </Flex>
            <Flex justifyContent='center' alignItems='center' width='100%'>
                {helpDeskUrlByLanguage && (
                    <NoneDecoratedLink
                        to={helpDeskUrlByLanguage}
                        rel="noopener noreferrer"
                        target="_blank"
                        aria-label={`Help center for ${productName}`}
                        onClick={() => { getGoToHelpDeskEvent(productName); }}
                    >
                        <IconExport height={16} width={16} />
                    </NoneDecoratedLink>
                )}
            </Flex>
        </Item>);
};

export default ProductItemWeb;